import React, { Component } from 'react';
import { Grid, Typography, Zoom, FormControlLabel, Switch, TextField, Modal, Button, Paper, MenuItem, InputLabel } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Delete from '@material-ui/icons/Delete';

import { msgAction, msgSimple } from '../../../actions/snackbarActions';
import { connect } from 'react-redux';

import AircraftsModelsService from '../../../tools/AircraftsModelsService';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';


class ModalAircrafts extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: '',
            zoom: false,
            aircraft: {
                id: 'new',
                marks: "",
                aircraft_model_id: "",
                sn: '',
                qty_pax: "",
                qty_crew: "",
                qty_bed: "",
                qty_bath: "",
                reach: "",
                observations: "",
                active: true,
                aircraft_model: {
                    icao_model: '',
                    tcds_model: ''
                },
                photo_id: null,
                change:false

            },
            photo: null,
            change:false,
            models: [],
        }
    }

    deleteImg = () => {

        let { aircraft } = this.state
        this.setState({
            photo: '',
            aircraft: { ...aircraft,photo:'',change:true },
            zoom: false
        });
    }

    onRender = () => {
        AircraftsModelsService.getActive().then(response => {
            if (response) {
                this.setState({ models: response.response })
            }

        })
        if (this.props.modal.id !== 'new') {
            this.setState({
                aircraft: this.props.modal,
                zoom: true
            })
            if(this.props.modal.photo){
                this.setState({photo: this.props.modal.photo.url +'?token=Bearer '+this.props.token})
            }
            else                
                this.setState({photo:''})
        }
        else {
            this.setState({
                aircraft: {
                    id: 'new',
                    marks: "",
                    aircraft_model_id: "",
                    sn: '',
                    qty_pax: "",
                    qty_crew: "",
                    qty_bed: "",
                    qty_bath: "",
                    reach: "",
                    observations: "",
                    active: true,
                    photo:'',
                    aircraft_model: {
                        icao_model: '',
                        tcds_model: ''
                    },
                    photo_id: null,
                    change:false
                },
                photo: null,
                change:false
            })
        }
    }



    render() {
        return (
            <Modal
                open={this.props.openModal}
                onRendered={this.onRender}
            >
                <Grid container justify="center" alignItems="center" style={{ height: '100%', width: '100%', overflowX: 'hidden' }} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid style={{ overflowX: 'auto' }} item container xs={12} sm={8} md={8} lg={8} xl={6}>
                        <Paper style={{ height: '100%', width: '100%', padding: 20 }}>
                            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography style={{ marginTop: 25 }} variant="title" id="modal-title">
                                    {this.props.modal.id ==='new' ? 'Nova Aeronave' : 'Editar Aeronave'}
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography style={{ marginTop: 14, marginRight: 10 }} variant="subheading" id="modal-title">
                                    Ativo:
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id='active'
                                            checked={this.state.aircraft.active}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, active: event.target.checked } })
                                            }}
                                            color="primary"
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: 0, margin: 0, marginBottom: 10 }}>
                                <Grid container spacing={8}>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={12} >
                                        <TextField
                                            id="mark"
                                            required
                                            label="Matrícula"
                                            style={{ width: '100%', margin: 2 }}
                                            value={this.state.aircraft.marks}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, marks: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={12}>
                                        <TextField
                                            select
                                            id="manufacturers"
                                            required
                                            label="Modelo"
                                            style={{ width: '100%', margin: 2 }}

                                            value={this.state.aircraft.aircraft_model_id}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, aircraft_model_id: event.target.value } })
                                            }}
                                            margin="normal"
                                        >
                                            <MenuItem disabled>
                                                Selecione o Modelo
                                            </MenuItem>
                                            {this.state.models && this.state.models.map(models => (
                                                <MenuItem key={models.id} value={models.id}>
                                                    {models.icao_model}{' / '}{models.tcds_model}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={8}>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <TextField
                                            id="teste"
                                            label="S/N"
                                            style={{ width: '100%' }}
                                            value={this.state.aircraft.sn}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, sn: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <TextField
                                            id="teste"
                                            label="Alcance (mi)"
                                            style={{ width: '100%', }}
                                            value={this.state.aircraft.reach}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, reach: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={16}>
                                    <Grid item xs={6} sm={12} md={6} lg={3} xl={2}>
                                        <TextField
                                            id="frist_name"
                                            label="Qty max pax"
                                            style={{ width: '100%', }}
                                            value={this.state.aircraft.qty_pax}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, qty_pax: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={12} md={6} lg={3} xl={2}>
                                        <TextField
                                            id="frist_name"
                                            label={<Typography style={{ color: 'rgba(0, 0, 0, 0.54)' }}> Qty max tripulantes</Typography>}
                                            style={{ width: '100%', }}
                                            value={this.state.aircraft.qty_crew}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, qty_crew: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={12} md={6} lg={3} xl={2}>
                                        <TextField
                                            id="frist_name"
                                            label="Qty Max. camas"
                                            style={{ width: '100%', }}
                                            value={this.state.aircraft.qty_bed}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, qty_bed: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={12} md={6} lg={3} xl={2}>
                                        <TextField
                                            id="frist_name"
                                            label="Qty toaletes"
                                            style={{ width: '100%', }}
                                            value={this.state.aircraft.qty_bath}
                                            onChange={event => {
                                                let { aircraft } = this.state;
                                                this.setState({ aircraft: { ...aircraft, qty_bath: event.target.value } })
                                            }}
                                            margin="normal"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <TextField
                                        id="frist_name"
                                        label="Observações"
                                        style={{ width: '100%' }}
                                        value={this.state.aircraft.observations}
                                        onChange={event => {
                                            let { aircraft } = this.state;
                                            this.setState({ aircraft: { ...aircraft, observations: event.target.value } })
                                        }}
                                        margin="normal"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid item container>
                                    <Typography style={{fontSize:20}}>
                                        Anexo:
                                    </Typography>
                                </Grid>
                                {!this.state.photo ?
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                        <TextField style={{ display: 'none' }} type='file' id='inputFile'
                                            onChange={event => {

                                                let imgFile = new FileReader();
                                                console.log('imgFile:',imgFile)
                                                let file = event.target.files[0]
                                                console.log('file:',file)

                                                imgFile.onloadend = () => {
                                                    let { aircraft } = this.state
                                                    let photo
                                                    photo = imgFile.result
                                                    this.setState({
                                                        photo: photo,
                                                        aircraft: {
                                                            ...aircraft,
                                                            photo: file,
                                                            change:true
                                                        },
                                                        zoom: true
                                                    })
                                                }
                                                imgFile.readAsDataURL(file)

                                                this.forceUpdate();
                                            }
                                            }
                                        />
                                        <InputLabel htmlFor='inputFile'>
                                            <Button variant="contained" component='span' style={{ width: '100%', height: '100%', padding: 0, margin: 0 }}>
                                                Anexar foto da aeronave
                                                        <CloudUploadIcon style={{ marginLeft: 5 }} />
                                            </Button>
                                        </InputLabel>
                                    </Grid>
                                </Grid>
                                :
                                <Grid container justify='flex-start' spacing={16}>
                                    <Zoom in={this.state.zoom}>
                                        <Grid style={{ margin: 10 }} item md={5}>
                                            <Card style={{ height: 200, width: 200 }}>
                                                <CardActions style={{ height: 160, width: 200, margin: 0, padding: 0, alignItems: 'center',display:'flex',justifyContent:'center' }}>
                                                    {this.state.photo && <img src={this.state.photo} style={{ maxHeight: 160, maxWidth: 200 }} />}
                                                </CardActions>
                                                <CardActions style={{ height: 40, width: 200, alignItems: 'center', justifyContent: 'flex-end', float: 'right' }}>
                                                    <Button style={{ float: 'right' }} onClick={() => this.deleteImg()} size="small" color="secondary">
                                                        Deletar
                                                        <Delete color='secondary' style={{ marginLeft: 5 }} />
                                                    </Button>
                                                </CardActions>
                                            </Card>
                                        </Grid>
                                    </Zoom>
                                </Grid>}
                            </Grid>
                            <Grid item container justify='flex-end' xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid item >
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                                if(this.state.aircraft.marks !== '' && this.state.aircraft.aircraft_model_id !== ''){
                                                    this.props.handleSave(this.state.aircraft)
                                                }
                                                else{
                                                    this.props.msgSimple('Preencha os campos obrigatórios.')
                                                }
                                            }
                                        }
                                    >
                                        Salvar
                                    </Button>

                                </Grid>
                                <Grid item >
                                    <Button
                                        color="secondary"
                                        onClick={() => this.props.func()}
                                    >
                                        Cancelar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.authReducer.token

})

const mapDispatchToProps = {
    msgSimple,
    msgAction
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalAircrafts)



// WEBPACK FOOTER //
// ./src/routes/settings/aircrafts/Modal.js